<template>
  <Vue-select
    class="custom-vue-select"
    v-model="selectedInternal"
    :options="data"
    label="name"
    placeholder="Escribir..."
    :reduce="data => data.id.toString()"
    @click="clearSelection"
    :components="{Deselect}"
  >
  <template v-slot:no-options="{ data, searching }">
    <template v-if="searching">
      <em style="opacity: 0.5">No se encontraron resultados {{ data }}</em>
    </template>
    <em v-else style="opacity: 0.5">No se encuentraron resultados</em>
  </template>
  </Vue-select>
</template>

<script>
  import { ref, watchEffect } from 'vue';
  
  export default {
    props: {
      data: Array,
      selectedBrandsCar: String
    },
    setup(props, { emit }) {
      const selectedInternal = ref(null);

      watchEffect(() => {
        if (props.selectedBrandsCar) {
          const selectedOption = props.data.find(option => option.id.toString() === props.selectedBrandsCar);
          selectedInternal.value = selectedOption;
        }
      });

      watchEffect(() => {
        if (selectedInternal.value !== null) {
          if (selectedInternal.value) {
            const selectedId = selectedInternal.value.id;

            const idAsString = selectedId ? selectedId.toString() : null;
            emit('update:selectedBrandsCar', selectedInternal.value);
            if (idAsString) {
              selectedInternal.value = idAsString;
              emit('update:selectedBrandsCar', idAsString);
            }
          }
        }
      });

      const clearSelection = () => {
        selectedInternal.value = '';
        emit('update:selectedCalibreArma', selectedInternal.value );
      };

      const Deselect = null;

    return {
      selectedInternal,
      clearSelection,
      Deselect
    };
  }
};
</script>